import React from "react"
import 'aos/dist/aos.css';
import '../css/styles.css'
import { motion } from 'framer-motion';
import Head from "../components/Head";
import { useIntl} from "gatsby-plugin-intl"

let Privacy = () => {
  const intl = useIntl();
  return (
    <section>
            <Head description={intl.formatMessage({ id: "meta_privacy" })}
        title={intl.formatMessage({ id: "privacy" })} />
      <motion.div initial="out" animate="in" exit="out">
        <div className="flex col justify-center mt-100">
          <h3 className="">
            Privacy Policy for 4BeautyMakeup
        </h3>
          <p className="">
            At www.4beautymakeup.com, accessible from www.anna.uk.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by www.4beautymakeup.com and how we use it.
        </p>
          <p className="">
            If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. Our Privacy Policy was generated with the help of GDPR Privacy Policy Generator from GDPRPrivacyNotice.com
        </p>
          <h3 className="">
            General Data Protection Regulation (GDPR)
        </h3>
          <p>
            We are a Data Controller of your information.
        </p>
          <p className="">
          4BeautyMakeup legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Information we collect and the specific context in which we collect the information:
        <ul>
              <li>
              4BeautyMakeup needs to perform a contract with you;
          </li>
              <li>
                You have given 4BeautyMakeup permission to do so;
          </li>
              <li>
                Processing your personal information is in 4BeautyMakeup legitimate interests;
          </li>
              <li>
              4BeautyMakeup needs to comply with the law;
          </li>
              <li>
                4BeautyMakeup will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
          </li>
            </ul>

          </p>
          <p className="">
            In certain circumstances, you have the following data protection rights:

        <ul>
              <li>
                The right to access, update or to delete the information we have on you.
          </li>
              <li>
                The right of rectification.
          </li>
              <li>
                The right to object.
          </li>
              <li>
                The right of restriction.
          </li>
              <li>
                The right to data portability
          </li>
              <li>
                The right to withdraw consent
          </li>
              <li>
                Log Files
          </li>
            </ul>
            www.4beautymakeup.com follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
        </p>

          <p className="">
            <h3>Privacy Policies</h3>
          You may consult this list to find the Privacy Policy for each of the advertising partners of www.4beautymakeup.com.
        </p>
          <p className="">
            Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on www.4beautymakeup.com, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
        </p>
          <p className="">
            Note that www.4beautymakeup.com has no access to or control over these cookies that are used by third-party advertisers.
        </p>
          <p className="">
            <h3>Third Party Privacy Policies</h3>
            www.4beautymakeup.com's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
        </p>
          <p className="">
            You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
        </p>
          <p className="">
            <h3>Children's Information</h3>

          Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.

        </p>
          <p className="">
          www.4beautymakeup.com does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
        </p>
          <p className="">
            <h3>Online Privacy Policy Only</h3>
          Our Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in www.4beautymakeup.com. This policy is not applicable to any information collected offline or via channels other than this website.
        </p><p className="">
            <h3>Consent</h3>
          By using our website, you hereby consent to our Privacy Policy and agree to its terms.
        </p>
        </div>
      </motion.div>
    </section>
  )
}
export default Privacy;